import { useEffect } from 'react';
import i18n from 'helpers/i18n';
import messages from './messages';
import { useRouteParams } from 'hooks/useRouteParams';
import { MeasureProvider } from 'context/measure';
import ClassAssessment from 'components/Measure/View/ClassAssessment';
import EnvScalesAssessment from 'components/Measure/View/EnvScalesAssessment';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { Assessment } from 'types/api/envScales/Assessment';
import {
  classMixedEditionAgeLevels,
  environmentsAgeLevels
} from 'constants/ageLevels';

type URLParams = {
  id: string;
};

const AGE_LEVEL_OPTIONS = [
  ...classMixedEditionAgeLevels,
  ...environmentsAgeLevels
];

function getAgeLevelText(ageLevel: string) {
  const option = AGE_LEVEL_OPTIONS.find(item => item.value === ageLevel);
  return (option?.text as string) ?? ageLevel;
}

function MeasureTitle({ assessment }: { assessment: Assessment }) {
  useDocumentTitle(
    i18n.ft(messages.title, { ageLevel: getAgeLevelText(assessment.age_level) })
  );
  return null;
}

function View() {
  const { id } = useRouteParams<URLParams>();
  const assessmentId = parseInt(id);

  useEffect(() => {
    document.title = i18n.ft(messages.loading);
  }, [id]);

  return (
    <MeasureProvider assessmentId={assessmentId} expanded>
      {value => (
        <>
          <MeasureTitle assessment={value.assessment} />
          {value.assessment.assessment_template.env_scales ? (
            <EnvScalesAssessment assessment={value.assessment} />
          ) : (
            <ClassAssessment />
          )}
        </>
      )}
    </MeasureProvider>
  );
}

export default View;
